<template>
  <div class="info-accout">
    <div class="setting-userinfo-account-container">
      <div class="setting-userinfo-account-upload">
        <p class="module-item-title">上传头像</p>
        <p class="setting-account-upload-tips">建议上传图片尺寸为60px*60px，若不设置则使用系统默认头像，你可以选择 jpg, gif, png 格式的图片，最大5M</p>
      </div>
      <div class="setting-userinfo-upload-box">
        <div class="upload-avatar-container" @click="chooseAvatarFile">
          <svg-icon icon-class="avatar-upload" class="el-icon-upload"></svg-icon>
          <div class="el-upload__text">选择一张本地图片上传</div>
          <input type="file" v-show="false" ref="uploadAvatarInput" @change="uploadAjax">
        </div>
      </div>
      <div class="setting-userinfo-account-preview">
        <p class="module-item-title">头像预览</p>
        <div class="setting-account-preview-img">
          <img :src="userinfo.csHeadimg" alt="">
        </div>
      </div>
      <span class="wl-btn" @click="resetAvatar">还原</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'info-accout',
    data() {
      return {
        accept: 'image/gif, image/jpeg, image/png, image/jpg',
      }
    },
    computed:{
      userinfo(){
        return this.$store.getters.user
      }
    },
    mounted() {

    },
    methods: {
      chooseAvatarFile() {
        this.$refs.uploadAvatarInput.click()
      },
      /**
       * 上传头像
       * @param e
       * @returns {boolean}
       */
      uploadAjax(e) {
        let img = e.target.files[0]
        let type = img.type
        let size = img.size
        if (this.accept.indexOf(type) == -1) {
          this.$message({
            showClose: true,
            message: '图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg',
            type: 'error',
            duration: 3 * 1000
          })
          return false
        }
        if (size > 5242880) {
          this.$message({
            showClose: true,
            message: '请选择5M以内的图片！',
            type: 'error',
            duration: 3 * 1000
          })
          return false
        }
        let formdata = new FormData()
        formdata.set('file', img)
        this.$http.editAvatarAPI(formdata).then( res => {
          if(res.status == 1){
            this.$message({
              message: res.msg,
              type: 'success'
            })
            this.userinfo.csHeadimg = res.data
          }
          let userinfo = this.userinfo
          this.$store.dispatch('user/changeUserInfo',userinfo)
        })
      },
      resetAvatar(){
        this.$http.resetAvatarAPI().then( res => {
          if(res.status == 1){
            this.$message({
              message: res.msg,
              type: 'success'
            })
            this.userinfo.csHeadimg = res.data
          }
          let userinfo = this.userinfo
          this.$store.dispatch('user/changeUserInfo',userinfo)
        })
      }
    }
  }
</script>

<style lang="scss">
.info-accout{
  .setting-userinfo-account-upload {
    display: flex;

    .setting-account-upload-title {
      font-size: 12px;
      color: #333333;
      font-weight: bold;
    }

    .setting-account-upload-tips {
      font-size: 12px;
      color: #999999;
      padding-left: 27px;
    }
  }

  .setting-userinfo-upload-box {
    margin: 33px 0;
    .upload-avatar-container{
      width: 150px;
      height: 150px;
      text-align: center;
      border: 1px solid #e4e7ed;
      background-color: #fafafa;
      cursor: pointer;
    }
    .avatar-uploader {
      width: 100%;
      height: 100%;
      background-color: #fafafa;
    }

    .el-icon-upload {
      margin-top: 20px;
      width: 53px;
      height: 75px;
      margin-right: 0;
    }

    .el-upload__text {
      color: #999999;
      font-size: 12px;
      margin-top: 10px;
    }

    .avatar-uploader .el-upload {
      height: 100%;
      width: 100%;
      border: 1px solid #e4e7ed;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
  }

  .setting-userinfo-account-preview {
    .setting-account-preview-title {
      font-size: 12px;
      color: #333333;
      font-weight: bold;
    }

    .setting-account-preview-img {
      padding: 30px 52px;

      img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
      }
    }
  }
}
</style>
